import React from 'react';
import { Button } from '../ui/button';
import { LogOut } from 'lucide-react';
import { InstallPushButtons } from '../InstallPushButtons';

export function GuardHeader({ user, navigate, handleLogout }) {
  return (
    <header className="bg-gk-navy text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src="/icon-192.png" alt="GateKeeper" className="w-10 h-10 rounded-lg" />
          <div>
            <h1 className="text-xl font-bold">Security Control</h1>
            <p className="text-sm text-slate-300">{user?.name}</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div
            data-testid="profile-icon"
            onClick={() => navigate('/profile')}
            className="w-9 h-9 rounded-full bg-gk-teal flex items-center justify-center cursor-pointer hover:bg-gk-teal-hover transition-colors"
            title="My Profile"
          >
            <span className="text-sm font-bold text-white">{user?.name?.[0]?.toUpperCase() || 'U'}</span>
          </div>
          <InstallPushButtons />
          <Button
            data-testid="logout-button"
            onClick={handleLogout}
            variant="ghost"
            className="text-white hover:bg-gk-navy-hl"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </Button>
        </div>
      </div>
    </header>
  );
}
